import { OverlayTrigger, Tooltip } from "react-bootstrap";
export default function TitleTooltip({
    title,
    placement,
    children
}) {
    return (
        <OverlayTrigger placement={placement} overlay={(props) => (<Tooltip {...props}><span>{title}</span></Tooltip>)} delay={{show: 250, hide: 300}}>
            {children}
        </OverlayTrigger>
    );
}
